import type { Theme } from '@mui/material/styles';

/** Vertical stack of a Home section: header above its card (mockup 1). */
export const sectionSx = { display: 'flex', flexDirection: 'column', gap: 1 } as const;

/** Separator between the rows of a list card (mockups: 1px #EEF1F4). */
export function rowDividerSx(theme: Theme): object {
  return { '&:not(:last-of-type)': { borderBottom: `1px solid ${theme.fx.neutralBg}` } };
}
